@if(loading$ | async){
<div class="spinner-overlay" role="status" aria-live="polite">
    <div class="spinner-wrapper">
        <div class="spinner" aria-hidden="true"></div>
        <span class="loading-message">{{ loadingService.getMessage() }}</span>
    </div>
</div>
}
